import React        from 'react'
import Axios        from 'axios'
import PropTypes    from 'prop-types';
import NumberFormat from 'react-number-format'
import Swal         from 'sweetalert2'
//import './assets/sweetAlert.scss'

// export const hostUrl = window.location.host 

// export const hostUrl = "ddseminovos.com.br"
// export const hostUrl = "urivel.com.br"
// export const hostUrl = "rainhaveiculos.com.br"
// export const hostUrl = "gabriellamultimarcas.com.br"
// export const hostUrl = "danielautooeste.com.br"
// export const hostUrl = "brasilcarveiculostoledo.com.br"
// export const hostUrl = "megamultimarcascascavel.com.br"
// export const hostUrl = "auto10multimarcas.com.br"
// export const hostUrl = "autoshowcascavel.com.br"
// export const hostUrl = "garagecarshop.com.br"
// export const hostUrl = "patiomotors.com.br"
// export const hostUrl = "pfcarmultimarcas.com.br"
// export const hostUrl = "gpautospe.com.br"
// export const hostUrl = "astraveiculos.com.br"
// export const hostUrl = "jbveiculos.com"
// export const hostUrl = "novaesrepasse.com.br"
// export const hostUrl = "reciferepasses.com.br"
// export const hostUrl = "autogorepasse.com.br"
export const hostUrl = "geovaneveiculos.com.br"

export const cmsHost = "https://www."+hostUrl+"/cms" //PRODUÇÃO
// export const cmsHost = "https://cms.bomdapeste.com"

// export const hostUrl = "template.bomdapeste.com"    //DESENVOLVIMENTO
// export const cmsHost = "https://"+hostUrl+"/cms"     //DESENVOLVIMENTO


export const copyright = "2026"

export const svgArrowsUpDown = (size=18) => {
  return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 576 512" style={{transform: 'rotate(90deg)'}}><g><path d="M422.6 278.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 176H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H434.7L377.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112zm-269.3 224l-112-112c-12.5-12.5-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L141.3 336H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H141.3l57.4 57.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"></path></g></svg>
} 

export function appendScript(url, callback=()=>{}){
  let script  = document.createElement('script')
  script.charset  = "utf-8" 
  script.src  = url
  script.onload = callback
  document.querySelector('body').appendChild(script)
}

export function appendMetaTag(name, content){
  let meta    = document.createElement('meta')
  meta.name   = name
  meta.content= content
  document.querySelector('head').appendChild(meta)
}

export function appendLinkTag(rel, href){
  let link    = document.createElement('link')
  link.rel    = rel
  link.href   = href
  document.querySelector('head').appendChild(link)
}

export function swalTimerDialog(title="", html="", icon="error", callback=()=>{}, timer=2000){
  Swal.fire({
      html,
      title,
      icon,
      timer,
      showConfirmButton: false
  }).then(()=>{ callback() })
}

export function uFirstCase(str){
  str = str.trim()
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export function isValidCPF(CPF) { const strCPF = CPF.replace(/[^\d]+/g, ''); let Soma = 0, Resto, i; if (strCPF === "00000000000") return false; for (i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i); Resto = (Soma * 10) % 11; if ((Resto === 10) || (Resto === 11)) Resto = 0; if (Resto !== parseInt(strCPF.substring(9, 10)) ) return false; Soma = 0; for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i); Resto = (Soma * 10) % 11; if ((Resto === 10) || (Resto === 11)) Resto = 0; if (Resto !== parseInt(strCPF.substring(10, 11) ) ) return false; return true; }

export function isValidCNPJ(c) {
  let cnpj = c.replace(/[^\d]+/g, '');
  if (cnpj === '') return false;
  if (cnpj.length !== 14)
      return false;
    
  // Elimina CNPJs invalidos conhecidos
  if (cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999")
      return false;

  // Valida DVs
  let tamanho = cnpj.length - 2,
  numeros = cnpj.substring(0, tamanho),
  digitos = cnpj.substring(tamanho),
  soma = 0,
  pos = tamanho - 7,
  i, resultado;
  for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  
  if (resultado !== digitos.charAt(0)*1)
      return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  
  if (resultado !== digitos.charAt(1)*1)
      return false;
  
  return true;
}

export async function getEndereco(cep){
		Axios.defaults.withCredentials = false
		let v		= onlyNumbers(cep),
			resp	= await Axios.get( window.location.protocol+'//viacep.com.br/ws/' + v +'/json/'),
			endereco= {}
		if(resp.status === 200){
			const {data} = resp
			endereco = {
				cep         :   data.cep,
				logradouro  :   data.logradouro,
				bairro      :   data.bairro,
				cidade      :   data.localidade,
				estado      :   data.uf
			}
		}
		Axios.defaults.withCredentials = true
		return endereco
}

export const isValidDate = (data) => {
  const dt = new Date(data.substr(-4)+"-"+data.substr(2,2)+"-"+data.substr(0,2)+ " 00:00:00")
  
  return dt instanceof Date && !isNaN(dt.valueOf())
  
}

export const isValidAnoFabMod = (anoMF) => {
  const ano = (new Date()).getFullYear()
  
  return anoMF*1>(ano-15) && anoMF*1<(ano+2) 
}

export const  isMobile = function() {var check = false;(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);return check;}

export const onlyNumbers = (txt) => txt.replace(/(?![0-9])./g,"")

export function isValidPhone(fone){ 
  var f=fone.replace(/[^0-9]/gm,''), re =/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/; return re.test(f) && f.length>9
}

export	function isValidEmail(email){
  const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|club|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b/i;
  return re.test(email);
}

export const getNumberFormat = (value) => (<NumberFormat value={value} displayType="text" decimalSeparator="," thousandSeparator="." />)

export const getNumberFormatTextMask = (value, mask) => (<NumberFormat value={value} displayType="text" format={mask} />)

export const setSelStock = (id, list, qtde) => {
    let    stock = list.filter(i => i._id!==id && i.foto.liberada),
           total = stock.length,
        selStock = [];
    //if(id & id.toString().length)
    //    stock = list.filter(i => i._id!==id && i.foto.liberada)
    if(total>qtde){
        for(let i=0; i<qtde; i++){
            let idx = Math.ceil(total*Math.random())
            if(stock[idx]){
                selStock.push(stock[idx])
                stock.splice(idx, 1)
                total--
            }else i--
        }
    }else selStock = stock
    return selStock
}

export const offsetElement = (el) => {
  var rect = el.getBoundingClientRect(),
  scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export const scrollTo = (pos=0) => { 
  try{
    window.scrollTo({top:pos, behavior: 'smooth'}) 
  }catch(e){
    window.scrollTo(0, pos)
  }
}

export const scrollToElement = (id,ajuste=0) => { 
    try{
      scrollTo(Math.ceil(offsetElement(document.getElementById(id)).top - ajuste)) 
    }catch(e){ }
}

export const getDescSplit = (txt) => {
    let desc = txt.trim().replace(/<\//g,'<').replace(/<v>/gi,"&nbsp;")
    return desc.split("&nbsp;")
}

export const putBR = (txt) => {
    let   desc = txt.split(/\n/g),
        result = desc.map((d, i) => <span key={i}>{d}<br/></span>);

    return <>{result}</>
}

export function NumberFormatCustom(props) {
    const { inputRef, onChange, name, id,...other } = props,
            obj = JSON.parse(name);
            
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            currentTarget: {
              id,
              value: values.value,
            },
          });
        }}

        format={obj.mask}
        displayType={obj.displayType}
        prefix={obj.prefix}
        sufix={obj.sufix}
        decimalSeparator=","
        thousandSeparator="."
        //isNumericString
      />
    );
  }
  
  NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  };